import React from 'react'
import UomsForm from './UomsForm'

const NewUomPage = () => {
  return (
    <>
     <UomsForm formType='create' currentUomId={null} ></UomsForm>
    </>
  )
}

export default NewUomPage
